export const FETCH_BALANCES = "FETCH_BALANCES";
export const FETCH_DEPOSITS_BY_DEPOSIT_DATE = "FETCH_DEPOSITS_BY_DEPOSIT_DATE";
